import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	toolTip: {
		id: 'business-timeline.timeline-view.list-item-content.tool-tip',
		defaultMessage: 'View Details',
		description: 'Tool tip message for issue key which opens issue details if clicked.',
	},
});
